import { render, staticRenderFns } from "./createProductsMain.vue?vue&type=template&id=7fe55cbd&scoped=true"
import script from "./createProductsMain.vue?vue&type=script&lang=js"
export * from "./createProductsMain.vue?vue&type=script&lang=js"
import style0 from "./createProductsMain.vue?vue&type=style&index=0&id=7fe55cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe55cbd",
  null
  
)

export default component.exports